import { createFileRoute } from '@tanstack/react-router';
import { LandingPageFrame } from '@/features/consumer/landing-pages/landing-page-frame';

const LANDING_PAGE_SRC = '/landing-pages/landing-page-v2.html';

export const Route = createFileRoute('/landing-page-v2')({
  component: LandingPageV2,
  head: () => ({
    meta: [
      {
        title:
          "Itria Home — Finally, a cleaning service you don't have to manage",
      },
      {
        name: 'description',
        content:
          'Trained, background-checked teams. The same crew every visit. Backed by a re-clean guarantee — so your home is handled, every time.',
      },
      { name: 'robots', content: 'noindex' },
    ],
  }),
});

function LandingPageV2() {
  return (
    <LandingPageFrame
      src={LANDING_PAGE_SRC}
      title="Itria Home — Finally, a cleaning service you don't have to manage"
      backgroundClassName="bg-black"
    />
  );
}
